import Dashboard from '../../pages/Dashboard';

const EitDashboardGate = () => {
  return <Dashboard />;
};

export default EitDashboardGate; 